import React, { useEffect, useState } from "react";
import { Download, FlaskConical, Coins } from "lucide-react";
import { api } from "@/lib/api";
import { PageHeader, SectionCard, KpiCard } from "@/components/Primitives";

export default function DataIntelligence() {
  const [port, setPort] = useState(null);
  const [trials, setTrials] = useState([]);
  const [mon, setMon] = useState(null);

  useEffect(() => {
    api.get("/data-intel/portability").then(r=>setPort(r.data));
    api.get("/data-intel/trials").then(r=>setTrials(r.data));
    api.get("/data-intel/monetization").then(r=>setMon(r.data));
  }, []);

  return (
    <>
      <PageHeader eyebrow="Module 24" title="Data Ownership & Monetization"
        subtitle="Export everything, match patients to trials, opt in to compensated research networks." testid="data-page" />

      <div className="grid grid-cols-1 md:grid-cols-3 gap-4 mb-6">
        <KpiCard icon={Download} label="Patient records" value={port?.patient_records ?? "—"} testid="kpi-records" />
        <KpiCard icon={FlaskConical} label="Active trial matches" value={trials.reduce((s,t)=>s+t.matching_patients,0)} testid="kpi-trials" />
        <KpiCard icon={Coins} label="Annual monetization value" value={mon ? `$${mon.estimated_annual_value.toLocaleString()}` : "—"} accent testid="kpi-mon" />
      </div>

      <div className="grid grid-cols-1 lg:grid-cols-2 gap-6">
        <SectionCard title="Data Portability" testid="portability">
          <div className="text-sm text-brand-muted mb-3">Export the complete clinical dataset in any compatible format.</div>
          <div className="flex flex-wrap gap-2">
            {port?.formats_available?.map(f=>(
              <button key={f} className="px-3 py-2 rounded-md border border-brand text-sm hover:bg-brand-bg inline-flex items-center gap-2" data-testid={`export-${f.replace(/\s/g,'-')}`}>
                <Download className="w-4 h-4" /> {f}
              </button>
            ))}
          </div>
        </SectionCard>

        <SectionCard title="Monetization Opt-in" testid="monetization">
          <div className="text-sm">Status: <span className={mon?.opt_in?"text-emerald-600 font-semibold":"text-brand-muted"}>{mon?.opt_in?"Opted in":"Not opted in"}</span></div>
          <div className="text-xs text-brand-muted mt-1">Compensated de-identified data sharing for research networks.</div>
          <ul className="mt-3 space-y-1 text-sm">
            {mon?.available_datasets?.map((d,i)=>(<li key={i}>• {d}</li>))}
          </ul>
          <button className="mt-3 bg-brand-teal text-white px-4 py-2 rounded-md text-sm font-medium" data-testid="optin-btn">Review opt-in agreement</button>
        </SectionCard>
      </div>

      <div className="mt-6">
        <SectionCard title="Clinical Trial Matching" subtitle="Patients in your panel matching active studies" testid="trials-section">
          <div className="space-y-2">
            {trials.map((t,i)=>(
              <div key={i} className="flex items-center justify-between p-3 border border-brand rounded-md hover:bg-brand-bg">
                <div>
                  <div className="text-sm font-medium">{t.trial}</div>
                  <div className="text-xs text-brand-muted">{t.phase} • {t.site}</div>
                </div>
                <span className="status-pill status-approved">{t.matching_patients} matches</span>
              </div>
            ))}
          </div>
        </SectionCard>
      </div>
    </>
  );
}
